import Query from './Query';
import GetSalesChannels from './getSalesChannels';
import GetPickerByEmail from './GetPickerByEmail';
import Mutation from './Mutation';
import AssignPicker from './assignPicker';

export {
    Query,
    GetSalesChannels,
    GetPickerByEmail,
    Mutation,
    AssignPicker
};
